import React from "react";
import Navbar from "../components/navbar";

import Data from "../components/data";

const DataPage = () => {
    return (
        <div>
            <Navbar />
            <Data />
        </div>
    );
}

export default DataPage;